<template>
    <div class="file-select-wrapper">
        <div v-if="!readonly" class="input-mode-toggles">
            <div class="input-mode-toggles-inner">
                <span
                    v-for="mode in inputModes"
                    :key="mode.key"
                    class="help-text input-mode-toggle"
                    :class="{'input-mode-toggle--active': mode === inputMode}"
                    @click="changeInputModeTo(mode)"
                >
                    {{ mode.label }}
                </span>
            </div>
        </div>
        <label v-if="fileModeIsActive"
               :for="inputId"
               class="file-select">
            <input
                :id="inputId"
                :required="required"
                type="file"
                :class="{'error-glow': error}"
                :readonly="readonly"
                @change="emitInput"
            />
        </label>
        <text-input
                v-else
                :input-id="inputId"
                :required="required"
                :error="error"
                as-text-area
                @input="emitInput"
                :readonly="readonly"
                :value = "typeof value == 'string' ? value : ''" />
    </div>
</template>

<script>
import TextInput from './TextInput'
import AutoFieldMixin from '../../mixins/AutoField'

export default {
  name: 'FileInput',
  mixins: [AutoFieldMixin],
  components: {
    TextInput
  },
  model: {
    prop: 'value',
    event: 'input'
  },
  props: {
    value: {
      type: [File, String],
      default: null
    },
    required: {
      type: Boolean,
      default: false
    },
    error: {
        type: Boolean,
        default: false
    },
    inputId: String,
    readonly: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    let inputModes = {
      file: {
        key: 'file',
        label: 'Из файла'
      },
      text: {
        key: 'text',
        label: 'Ввести текст'
      }
    };
    return {
      inputModes,
      inputMode: this.readonly || this.value && typeof this.value == "string"
        ? inputModes.text
        : inputModes.file
    }
  },
  computed: {
    fileModeIsActive() {
      return this.inputMode === this.inputModes.file
    },
    isValueTypeValid() {
      return this.value && typeof this.value.name === 'string'
    },
    defaultValue() {
      return this.fileModeIsActive ? new File([''], 'empty') : ""
    }
  },
  methods: {
    valueToSendFromEvent(e) {
      if (this.fileModeIsActive) {
        return e.target.files[0]
      } else {
        return new File([e], this.inputId)
      }
    },
    changeInputModeTo(mode) {
      this.inputMode = mode
    }
  },
}
</script>

<style lang="sass" scoped>
    .file-select-wrapper
        margin-bottom: gridSteps(2)

    .file-select > .select-button
        padding: 1rem
        color: white
        background-color: #2EA169
        border-radius: .3rem
        text-align: center
        font-weight: bold

    .input-mode-toggles
        margin-bottom: gridSteps(1.5)

    .input-mode-toggles-inner
        background: $light-grey
        border-radius: gridSteps(1)
        display: inline-flex
        align-items: center
        overflow: hidden

    .input-mode-toggle
        padding: gridSteps(0.5) gridSteps(1)
        cursor: pointer
        display: inline-block
        text-align: center
        border-radius: gridSteps(1)
        width: 100px
        flex-grow: 1

        &--active
            background: $dark-blue
            box-shadow: $standard-elevation
            color: white

</style>
